export const passportValidator = (input: string) => {
  const inputRegex = /^[A-Za-z]{2}\d{6}$/;
  if (inputRegex.test(input)) {
    return true;
  } else {
    return false;
  }
};
